// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"em","pgSpeechBox":"em","speech-list-box":"en","speechListBox":"en"};